module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "dedicationPage"
  }, [_c('a', {
    attrs: {
      "id": "title18"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "p-c-br"
  }, [_c('span', [_vm._v("For my husband, David, who, "), _c('br'), _vm._v("after twenty books, is still supportive, "), _c('br'), _vm._v("still indulgent and still cooking. "), _c('br'), _vm._v("I couldn’t have done it without you. "), _c('br'), _vm._v("Here’s to twenty more.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-c-br"
  }, [_c('span', [_vm._v("And with much, much gratitude to "), _c('br'), _vm._v("Captain George Meyers (AKA Roscoe) of "), _c('br'), _vm._v("Chicago, Illinois, who, happily and with great humor, "), _c('br'), _vm._v("answered an exhaustive list of questions about his fire- "), _c('br'), _vm._v("fighting profession, and who added more than a little "), _c('br'), _vm._v("color to the book as a result. Any inaccuracies that may "), _c('br'), _vm._v("appear in the story do so because of my own "), _c('br'), _vm._v("erroneously drawn conclusions. "), _c('br'), _vm._v("Thanks, George!")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08e00ee2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781459271517_ded01.vue
// module id = 75
// module chunks = 0